import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import { breadcrumbScript, SITE_URL } from "@/lib/seo";

const relatedBySector: Record<string, string[]> = {
  accountants: [
    "how-accountancy-websites-can-improve-enquiry-quality",
    "local-seo-for-accountancy-firms-what-matters-most",
    "barnsley-seo-for-accountants-how-to-attract-higher-value-leads",
  ],
  hairdressers: [
    "how-hairdressers-can-get-more-bookings-from-google",
    "salon-treatment-pages-that-improve-seo-performance",
    "local-seo-and-the-consumer-journey",
  ],
  "law-firms": [
    "how-law-firms-can-improve-search-led-enquiry-quality",
    "barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries",
    "quality-content-and-e-e-a-t-raising-the-bar-for-trust",
  ],
  solicitors: [
    "barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries",
    "how-law-firms-can-improve-search-led-enquiry-quality",
    "why-seo-should-be-driving-your-business-growth-not-just-rankings",
  ],
  "private-dental-practices": [
    "private-dental-seo-treatment-pages-that-convert-patients",
    "barnsley-seo-for-dental-and-health-clinics-local-patient-growth",
    "quality-content-and-e-e-a-t-raising-the-bar-for-trust",
  ],
};

export const Route = createFileRoute("/seo/sectors/$sector")({
  loader: ({ params }) => {
    const key = `/seo/sectors/${params.sector}`;
    const page = getPage(key);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData, params }) => {
    const url = `https://www.phil-carr.co.uk/seo/sectors/${params.sector}`;
    return {
      meta: loaderData
        ? [
            { title: loaderData.title },
            { name: "description", content: loaderData.description },
            { property: "og:title", content: loaderData.title },
            { property: "og:description", content: loaderData.description },
            { property: "og:url", content: url },
          ]
        : [],
      links: loaderData ? [{ rel: "canonical", href: url }] : [],
      scripts: loaderData
        ? [
            breadcrumbScript([
              { name: "Home", url: `${SITE_URL}/` },
              { name: "SEO", url: `${SITE_URL}/seo` },
              { name: loaderData.title, url },
            ]),
          ]
        : [],
    };
  },
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
      <p className="mt-4 text-muted-foreground">That sector page is not available yet.</p>
    </div>
  ),
  component: SectorPage,
});

function SectorPage() {
  const page = Route.useLoaderData();
  const { sector } = Route.useParams();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      relatedSlugs={relatedBySector[sector]}
    />
  );
}
